import { ApplicationQuoteType } from '@amsanalytics/react-shared-library';

/**
 * Dealer-service history (DealerCreatedApplicationData: applications received,
 * decisions sent, comments, acknowledgements) is only ever written for indirect
 * applications — DealerTrack, RouteOne, and Dealer Flow all produce it.
 *
 * This was previously gated on the client-level "DealerTrack" feature flag, added in
 * 2021 when the endpoint served DealerTrack only. RouteOne and Dealer Flow branches
 * were added later, leaving the Application History card rendering with nothing in it
 * for any client without that flag.
 */
export const shouldLoadDealerServiceHistory = (
  application: { quoteType?: ApplicationQuoteType } | undefined | null
): boolean => (application?.quoteType === ApplicationQuoteType.Indirect);
